import React from 'react';
import PropTypes from 'prop-types';
import DollarsAndCents from '../DollarsAndCents';
import CurrencyHelper from '../../Helpers/CurrencyHelper';

const View = ({
  hostLiquorHide,
  terrorismHide,
  damageToRentedProperty,
  // liquorLiabilityHide,
  // personalPropertyHide,
  show,
  liquorPrice,
  sellingLiquor,
  damageToRentedPropertyPrice,
}) =>
  show && (
    <>
      {!terrorismHide && (
        <div className="form-row mb-3">
          <div className="col-auto w--70 font-weight-bold">
            <DollarsAndCents
              currency={new CurrencyHelper().setValue(0)}
              cents={false}
            />
          </div>
          <div className="col my-auto">
            Terrorism Coverage &mdash;
            <span className="font-italic"> included</span>
          </div>
        </div>
      )}

      {!hostLiquorHide && (
        <div className="form-row mb-3">
          <div className="col-auto w--70 font-weight-bold">
            <DollarsAndCents
              currency={new CurrencyHelper().setValue(0)}
              cents={false}
            />
          </div>
          <div className="col my-auto">Host Liquor (included)</div>
        </div>
      )}

      {sellingLiquor && (
        <div className="form-row mb-3">
          <div className="col-auto w--70 font-weight-bold">
            <DollarsAndCents
              currency={new CurrencyHelper()
                .setValue(liquorPrice)
                .convertFromInt()}
              cents={false}
            />
          </div>
          <div className="col my-auto">Selling Liquor (liquor liability)</div>
        </div>
      )}

      {damageToRentedProperty && (
        <div className="form-row mb-3">
          <div className="col-auto w--70 font-weight-bold">
            <DollarsAndCents
              currency={new CurrencyHelper()
                .setValue(damageToRentedPropertyPrice)
                .convertFromInt()}
              cents={false}
            />
          </div>
          <div className="col my-auto">Damage to Rented Premises</div>
        </div>
      )}

      {!sellingLiquor && !damageToRentedProperty && (
        <div className="form-row mb-3">
          <div className="col-auto w--70 font-weight-bold">{`${' '}`}</div>
          <div className="col my-auto">No Additional Coverages selected</div>
        </div>
      )}
    </>
  );
View.propTypes = {
  show: PropTypes.bool.isRequired,
  liquorPrice: PropTypes.number.isRequired,
  damageToRentedPropertyPrice: PropTypes.number.isRequired,
  sellingLiquor: PropTypes.bool.isRequired,
  hostLiquorHide: PropTypes.bool.isRequired,
  terrorismHide: PropTypes.bool.isRequired,
  damageToRentedProperty: PropTypes.bool.isRequired,
  // liquorLiabilityHide: PropTypes.bool.isRequired,
  // personalPropertyHide: PropTypes.bool.isRequired,
};

export default View;
